<template>
<div class="course" :data-pubid="myCourse.pubid">
    <a :id="myCourse.pubid"></a>
    <article :class="{deleted: !!myCourse.deleted || !!myCourse.cancelled}">
        <h3>
            <a
                :href="'/courses/' + myCourse.pubid"
                title="View detail"
                v-text="myCourse.cName"
            />
            <span
                v-if="!!myCourse.deleted || !!myCourse.cancelled"
                ossignore
                v-text="!!myCourse.deleted ? 'Deleted' : 'Cancelled'"
            />
        </h3>

        <h4
            ossignore
        >
            <template v-for="(instructor, i) in myCourse.instructors">
                <a
                    :href="'/instructors/' + instructor.pubid"
                    v-text="instructor.nameFormatted"
                /><template v-if="i < (myCourse.instructors.length - 1)">, </template>
            </template>
        </h4>

        <time>{{ myCourse.dateRangeFormatted}}</time>

        <time v-html="myCourse.schedule" />

        <div ossignore v-html="myCourse.location" />

        <div v-html="withDetail ? myCourse.descLong : myCourse.descShort" />

        <div ossignore class="instructors" v-if="withDetail">
            <h5>About the instructor{{ myCourse.instructors.length > 1 ? 's' : ''}}</h5>
            <div v-for="instructor in myCourse.instructors" v-html="instructor.descLong" />
        </div>

        <div class="enrollmentDetails" ossignore>
            <template v-if="user.isAdmin">
                <span v-if="!myCourse.deleted">
                    {{ myCourse.enrollmentCounts.nConfirmed }} of {{ myCourse.maxEnroll }} filled<br>
                    {{ myCourse.enrollmentCounts.nReserved }} reserved<br>
                    {{ myCourse.enrollmentCounts.nWaitlist }} waiting
                </span>
                <span>
                    <a
                        :href="'/courses/' + myCourse.pubid + '/edit'"
                        title="Edit"
                    >
                        <i class="icon-edit"></i>
                    </a>
				    <a
                        :href="'/courses/' + myCourse.pubid + '/enrollments'"
                        title="Enrollments"
                    >
                        <i class="icon-student"></i>
                    </a>
                    <a
                        :href="'/courses/' + myCourse.pubid + '/reviews'"
                        :title="myCourse.nRatings + ' reviews'"
                        :class="{noRatings: myCourse.nRatings === 0}"
                    >
                        <i class="icon-comment"></i>
                    </a>
			        <button
                        v-if="!myCourse.deleted"
                        class="admin-delete formLink"
                        :class="{ajaxPending: ajax.pending}"
                        title="Delete"
                        @click="doDelete"
                    >
                        <i class="icon-delete"></i>
                    </button>
			        <button
                        v-else
                        class="admin-restore formLink"
                        :class="{ajaxPending: ajax.pending}"
                        title="Restore"
                        @click="doRestore"
                    >
                        <i class="icon-restore"></i>
                    </button>
                </span>
                <span
                    v-if="!myCourse.deleted"
                >
<!--
                    <button
                        class="admin-button formLink"
                        :class="{ajaxPending: ajax.pending}"
                        title="Send student list to students"
                        @click="confirmSLS"
                    >
                        Send student list to students
                    </button>
-->
                    <button
                        class="admin-button formLink"
                        :class="{ajaxPending: ajax.pending}"
                        title="Send student emails"
                        @click="confirmSE"
                    >
                        Send student emails
                    </button>
                    <button
                        class="admin-button formLink"
                        :class="{ajaxPending: ajax.pending}"
                        title="Send student list to instructor"
                        @click="confirmSLI"
                    >
                        Send student list to instructor
                    </button>
                </span>
            </template>
            <span v-else class="enrollControl">
                <template v-if="!myCourse.cancelled">
                    <i v-if="regStatus === REGISTRATION_PAST">
                        Registration closed
                    </i>
                    <template v-else-if="regStatus === REGISTRATION_NOW">
                        <span
                            v-if="spacesAvailable"
                            v-text="spacesAvailable + ' spaces open'"
                        />
                        <span
                            v-else
                            v-text="'Waitlist open'"
                        />
                        <template v-if="user.isStudent">
                            <span
                                v-if="ajax.pending"
                                class="note"
                                v-text="'Talking to server...'"
                            />
                            <a
                                v-else-if="myCourse.myEnrollmentStatus === ENROLLMENT_CONFIRMED"
                                href="/enrollments"
                                class="note"
                                title="View enrollments"
                                v-text="'Confirmed'"
                            />
                            <template v-else-if="myCourse.myEnrollmentStatus === ENROLLMENT_RESERVED || myCourse.myEnrollmentStatus === ENROLLMENT_WAITLIST">
                                <a
                                    href="/enrollments"
                                    class="note"
                                    title="View enrollments"
                                    v-text="myCourse.myEnrollmentStatus === ENROLLMENT_RESERVED ? 'Reserved' : 'On waitlist'"
                                />
                                <button
                                    class="admin-disenroll formLink"
                                    title="Drop"
                                    name="disenroll"
                                    :value="myCourse.pubid"
                                    @click="confirmDisenroll($event)"
                                >
                                    <i class="icon-delete"></i>
                                </button>
                            </template>
                            <template v-else>
                                <button
                                    class="admin-enroll formLink"
                                    name="enroll"
                                    :value="myCourse.pubid"
                                    @click="enroll($event)"
                                >
                                    <i class="icon-enroll"></i>
                                    <span v-text="spacesAvailable ? 'Enroll' : 'Join waiting list'"></span>
                                </button>
                            </template>
                        </template>
                        <template v-else>
                            <a class="admin-enroll formLink" href="/login?redirect=courses">Login to enroll</a>
                        </template>
                    </template>
                    <i v-else-if="regStatus === REGISTRATION_FUTURE">
                        Registration opens {{ enrollmentStarts.format('MMMM D, YYYY')}} at {{ enrollmentStarts.format('h:mm a')}}
                    </i>
                    <i v-else>
                        Registration not open
                    </i>
                </template>
            </span>
        </div>
    </article>
</div>
</template>

<script>
import axios from 'axios';
import tippy, {hideAll} from 'tippy.js';

export default {
    props: {
        course: {
            type: Object,
        },
        user: {
            type: Object,
        },
        regStatus: {
            type: Number,
        },
        enrollmentStarts: {
            type: Object,
        },
        withDetail: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            myCourse: this.course,
            ajax: {
                pending: false,
            }
        };
    },
    computed: {
        spacesAvailable() {
            return this.myCourse.maxEnroll - this.myCourse.enrollmentCounts.nConfirmed - this.myCourse.enrollmentCounts.nReserved;
        }
    },
    methods: {
        confirmDisenroll($event) {
            if (this.somethingPending()) { return; }
            this.showConfirm(
                $event.target,
                'Are you sure you want to cancel your reservation?',
                'disenroll'
            );
        },

        // confirmSLS($event) {
        //     if (this.somethingPending()) { return; }
        //     this.showConfirm(
        //         $event.target,
        //         'Are you sure you want to send the student list to all enrolled students?',
        //         'sls'
        //     );
        // },

        confirmSE($event) {
            if (this.somethingPending()) { return; }
            this.showConfirm(
                $event.target,
                'Are you sure you want to send the student emails?',
                'se'
            );
        },

        confirmSLI($event) {
            if (this.somethingPending()) { return; }
            this.showConfirm(
                $event.target,
                'Are you sure you want to send the student list to the instructor?',
                'sli'
            );
        },

        showConfirm(target, message, action) {
            hideAll({duration: 0});
            tippy(target, {
                content: '<div>' + message + '</div><button class="confirm-' + action + '">Yes</button><button class="no">No</button>',
                allowHTML: true,
                interactive: true,
                showOnCreate: true,
                trigger: 'manual',
                maxWidth: 'none',
                placement: 'top-end',
            });
        },

        enroll() {
            let vue = this;
            vue.ajax.pending = true;
            axios.post('/courses', {
                enroll: vue.myCourse.pubid,
                ajax: true,
            })
                .then(response => {
                    if (response.data.status === 'error') {
                        $.growl.notice({
                            title: '',
                            message: response.data.message || 'Bad request.',
                            fixed: true,
                        });
                    } else {
                        let props = ['', 'nReserved', 'nConfirmed', 'nWaitlist'];
                        vue.myCourse.enrollmentCounts[props[response.data.enrollment_status]]++;
                        vue.myCourse.myEnrollmentStatus = response.data.enrollment_status;
                        let message = null;
                        if (response.data.enrollment_status === this.ENROLLMENT_RESERVED) {
                            message = 'Your space in <span class="notificationCourseName">'
                                + vue.myCourse.cName + '</span> has been reserved.'
                                + '<br><br>When you are done selecting courses, '
                                + '<a href="/cart">go to your cart</a> to pay and confirm your enrollment.';
                        } else if (response.data.enrollment_status === this.ENROLLMENT_WAITLIST) {
                            message = 'You have been added to the wait list for <span class="notificationCourseName">'
                                + vue.myCourse.cName + '</span>.';
                        }
                        if (message) {
                            $.growl.notice({
                                title: '',
                                message,
                                fixed: true,
                            });
                        }
                        this.updateCartBlock(response.data);
                    }
                })
                .catch(error => {
                    console.error(error);
                    $.growl.error({
                        title: '',
                        message: 'Problem reserving space for <i>' + vue.myCourse.cName + '</i>.',
                    });
                })
                .finally(() => {
                    vue.ajax.pending = false;
                })
            ;
        },

        disenroll() {
            let vue = this;
            hideAll();
            vue.ajax.pending = true;
            axios.post('/courses', {
                disenroll: vue.myCourse.pubid,
                ajax: true,
            })
                .then(response => {
                    let props = ['', 'nReserved', 'nConfirmed', 'nWaitlist'];
                    vue.myCourse.enrollmentCounts[props[vue.myCourse.myEnrollmentStatus]]--;
                    vue.myCourse.myEnrollmentStatus = null;
                    $.growl.notice({
                        title: '',
                        message: 'Reservation for <i>' + vue.myCourse.cName + '</i> cancelled.',
                    });
                    this.updateCartBlock(response.data);
                })
                .catch(error => {
                    console.error(error);
                    $.growl.error({
                        title: '',
                        message: 'Problem cancelling reservation for <i>' + vue.myCourse.cName + '</i>.',
                    });
                })
                .finally(() => {
                    vue.ajax.pending = false;
                })
            ;
        },
        updateCartBlock(data) {
            let cartLabel = document.getElementById('cartLabel');
            if (data.cartTotal > 0) {
                cartLabel.innerHTML = 'Cart total $' + data.cartTotal;
            } else {
                cartLabel.innerHTML = 'Cart is empty';
            }
        },
        doDelete() {
            if (this.somethingPending()) { return; }
            let vue = this;
            vue.ajax.pending = true;
            axios.post('/courses', {
                delete: 'foo_' + vue.myCourse.pubid,
                ajax: true,
            })
                .then(response => {
                    vue.myCourse.deleted = 1;
                    $.growl.notice({
                        title: '',
                        message: 'Deleted <i>' + vue.myCourse.cName + '</i>.',
                    });
                })
                .catch(error => {
                    console.error(error);
                    $.growl.error({
                        title: '',
                        message: 'Problem deleting <i>' + vue.myCourse.cName + '</i>.',
                    });
                })
                .finally(() => {
                    vue.ajax.pending = false;
                })
            ;
        },
        doRestore() {
            if (this.somethingPending()) { return; }
            let vue = this;
            vue.ajax.pending = true;
            axios.post('/courses', {
                restore: 'foo_' + vue.myCourse.pubid,
                ajax: true,
            })
                .then(response => {
                    vue.myCourse.deleted = 0;
                    $.growl.notice({
                        title: '',
                        message: 'Restored <i>' + vue.myCourse.cName + '</i>.',
                    });
                })
                .catch(error => {
                    console.error(error);
                    $.growl.error({
                        title: '',
                        message: 'Problem restoring <i>' + vue.myCourse.cName + '</i>.',
                    });
                })
                .finally(() => {
                    vue.ajax.pending = false;
                })
            ;
        },
        // sendStudentListToStudents() {
        //     let vue = this;
        //     hideAll();
        //     vue.ajax.pending = true;
        //     axios.post('/courses/' + vue.myCourse.pubid + '/send-student-list-to-students')
        //         .then(response => {
        //             $.growl.notice({
        //                 title: '',
        //                 message: 'Queued email of student list to students for <i>' + vue.myCourse.cName + '</i>.',
        //             });
        //         })
        //         .catch(error => {
        //             console.error(error);
        //             $.growl.error({
        //                 title: '',
        //                 message: 'Problem queuing student list to students for <i>' + vue.myCourse.cName + '</i>.',
        //             });
        //         })
        //         .finally(() => {
        //             vue.ajax.pending = false;
        //         })
        //     ;
        // },
        sendStudentEmails() {
            let vue = this;
            hideAll();
            vue.ajax.pending = true;
            axios.post('/courses/' + vue.myCourse.pubid + '/send-student-emails')
                .then(response => {
                    $.growl.notice({
                        title: '',
                        message: 'Queued student emails for <i>' + vue.myCourse.cName + '</i>.',
                    });
                })
                .catch(error => {
                    console.error(error);
                    $.growl.error({
                        title: '',
                        message: 'Problem queuing student emails for <i>' + vue.myCourse.cName + '</i>.',
                    });
                })
                .finally(() => {
                    vue.ajax.pending = false;
                })
            ;
        },
        sendStudentListToInstructor() {
            let vue = this;
            hideAll();
            vue.ajax.pending = true;
            axios.post('/courses/' + vue.myCourse.pubid + '/send-student-list-to-instructor')
                .then(response => {
                    $.growl.notice({
                        title: '',
                        message: 'Queued email of student list to instructor for <i>' + vue.myCourse.cName + '</i>.',
                    });
                })
                .catch(error => {
                    console.error(error);
                    $.growl.error({
                        title: '',
                        message: 'Problem queuing student list to instructor for <i>' + vue.myCourse.cName + '</i>.',
                    });
                })
                .finally(() => {
                    vue.ajax.pending = false;
                })
            ;
        },
        somethingPending() {
            if (this.ajax.pending) {
                $.growl.error({
                    title: '',
                    message: 'Cannot do this while another action is pending.',
                });
            }
            return this.ajax.pending;
        }
    },
    created() {
        this.REGISTRATION_PAST = 1;
        this.REGISTRATION_NOW = 2;
        this.REGISTRATION_FUTURE = 3;

        this.ENROLLMENT_RESERVED = 1;
        this.ENROLLMENT_CONFIRMED = 2;
        this.ENROLLMENT_WAITLIST = 3;
    },
    mounted() {
        let vue = this;
        document.querySelector('div.course[data-pubid="' + this.myCourse.pubid + '"]')
            .addEventListener('click', (evt) => {
                if (evt.target.classList.contains('no')) {
                    hideAll();
                }
                if (evt.target.classList.contains('confirm-disenroll')) {
                    vue.disenroll();
                }
                // if (evt.target.classList.contains('confirm-sls')) {
                //     vue.sendStudentListToStudents();
                // }
                if (evt.target.classList.contains('confirm-se')) {
                    vue.sendStudentEmails();
                }
                if (evt.target.classList.contains('confirm-sli')) {
                    vue.sendStudentListToInstructor();
                }
            })
        ;
    },
}
</script>

<style lang="scss">
@import '~tippy.js/dist/tippy.css';
div.course {
    .tippy-box {
        background-color: #d8842e;
    }
    .tippy-content {
        padding: 10px;
        & > * {
            font-size: 1.2rem !important;
            line-height: 100%;
            color: white;
            font-weight: normal;
        }
        button {
            padding: 2px 10px;
            background-color: white;
            color: #1a6e74;
            margin: 0 10px;
            border-radius: 4px;
            border: 1px solid #1a6e74;
        }
    }
    .tippy-box[data-placement^="top"] > .tippy-arrow::before {
        bottom: -20px;
        border-width: 10px 10px 0;
        border-top-color: #d8842e;
    }
    .instructors {
        font-size: unset;
    }
    .ajaxPending {
        cursor: not-allowed;
        opacity: 0.5;
    }
}
</style>
